import { CustomerAccountSummaryDto, CustomerProductDto } from "@/api/models/customer";
import { CustomerState } from "./customer";
import { CustomerBillingAccountDto } from "@/api/models/customer/customerBilling.model";
import { CUSTOMER_MUTATION_TYPES } from "./constants";

const SET_CUSTOMER = (state: CustomerState, customer: CustomerAccountSummaryDto) => {
	state.customer = {
		...customer
	};
};

const SET_BILLING = (state: CustomerState, billing: CustomerBillingAccountDto) => {
	state.billing = {
		...billing
	};
};

const SET_CUSTOMER_PRODUCT = (state: CustomerState, customerProduct: CustomerProductDto) => {
	state.customerProduct = {
		...customerProduct
	};
};

export default {
	[CUSTOMER_MUTATION_TYPES.SET_CUSTOMER]: SET_CUSTOMER,
	[CUSTOMER_MUTATION_TYPES.SET_BILLING]: SET_BILLING,
	[CUSTOMER_MUTATION_TYPES.SET_CUSTOMER_PRODUCT]: SET_CUSTOMER_PRODUCT
};
